"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditColumnMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const table_columns_1 = require("../../table-columns");
const attributes_1 = require("../../../constants/attributes");
const icons_1 = require("../../../../icons");
const localization_1 = require("../../../../localization");
// Special columns that should not show Edit menu item
const EXCLUDED_ATTRIBUTES = [
    attributes_1.PRODUCT_PAGE_URL_LABEL,
    attributes_1.PRODUCT_IMAGE_LABEL,
    attributes_1.CustomProductAttributes.ClassificationProductType,
];
const EditColumnMenuItem = ({ colDef, onClick, onEdit, hasSelection = false, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { label, dataMeta } = (0, table_columns_1.parseColumnId)(colDef.field);
    const { isAIEnriched, isMeasure } = dataMeta;
    const isEnriched = isAIEnriched && !isMeasure && !EXCLUDED_ATTRIBUTES.includes(label);
    if (!isEnriched)
        return null;
    if (!onEdit)
        return null;
    if (!hasSelection)
        return null;
    const handleClick = (event) => {
        onEdit === null || onEdit === void 0 ? void 0 : onEdit(label);
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    return (react_1.default.createElement(material_1.MenuItem, { onClick: handleClick }, react_1.default.createElement(material_1.ListItemIcon, null, react_1.default.createElement(icons_1.EditIcon, { fontSize: "small" })), react_1.default.createElement(material_1.ListItemText, null, t({ key: 'EDIT' }))));
};
exports.EditColumnMenuItem = EditColumnMenuItem;
